import { useReveal } from "@/lib/hooks";

export default function OurStory() {
  const ref = useReveal();
  return (
    <section
      data-testid="story-section"
      className="paper-texture py-28 md:py-36 px-6"
    >
      <div ref={ref} className="reveal max-w-3xl mx-auto text-center">
        <p className="text-[10px] tracking-luxe uppercase text-[#6A1E2D] mb-6">A note from us</p>
        <h2 className="font-display font-light text-4xl md:text-5xl lg:text-6xl text-[#1A1818] leading-[1.05] mb-8">
          We are delighted to invite you to
          <span className="italic text-[#6A1E2D]"> our wedding day</span>.
        </h2>
        <p className="font-body text-[#4A4747] text-base md:text-lg leading-relaxed">
          The day will be full of fun, dancing, lakes, trains, lego, drinks,
          cake, dinner, photos and more. We hope you like our website and find
          it informative. Remember to RSVP at the bottom before{" "}
          <strong className="text-[#1A1818] font-medium">1st March 2027</strong>!
        </p>
        <div className="divider-ornament mt-10 text-[#6A1E2D]">
          <span className="font-display italic text-base text-[#6A1E2D]">M &amp; N</span>
        </div>
      </div>
    </section>
  );
}
